import React, { useEffect, useState } from 'react'
import './Home.css';
import { db } from './firebase';

// Components
import Product from './Product';

function Home() {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        db.collection('products')
            .onSnapshot(snapshot => (
                setProducts(snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })))
            ))
    }, []);

    return (
        <div className="home">
            <div className="home__container">
                <img 
                    className="home__image"
                    src="https://images-eu.ssl-images-amazon.com/images/G/31/img19/AmazonDevices/GW/Akai-GW-Banner_PC_1X._CB414374623_.jpg"
                    alt="home backgrounf"
                />

                <div className="home__row">
                    {products.slice(0,2).map(product => {
                        return <Product 
                                    key={product.data.title}
                                    id={product.id} 
                                    title={product.data.title} 
                                    price={product.data.price} 
                                    image={product.data.image} 
                                    rating={product.data.rating} 
                                />
                    })}
                </div>
                <div className="home__row">
                    {products.slice(2,5).map(product => {
                        return <Product 
                                    key={product.data.title}
                                    id={product.id} 
                                    title={product.data.title} 
                                    price={product.data.price} 
                                    image={product.data.image} 
                                    rating={product.data.rating} 
                                />
                    })}
                </div>
                <div className="home__row">
                    {products.slice(5,6).map(product => {
                        return <Product 
                                    key={product.data.title}
                                    id={product.id} 
                                    title={product.data.title} 
                                    price={product.data.price} 
                                    image={product.data.image} 
                                    rating={product.data.rating} 
                                />
                    })}
                </div>
            </div>            
        </div>
    )
}

export default Home;
